// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"46d98603","455":"44c1567f","977":"d39b175c"}[chunkId] + ".chunk.js";
};